import { message } from 'antd';
import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom';

export default function GetQueryParamErrors() {
    const location = useLocation();
    const getQueryParams = (query) => {
        return new URLSearchParams(query);
    }
    const shownBefore = useRef(false);
    const queryParams = getQueryParams(location.search);
    useEffect(() =>{
        if (shownBefore.current) return;
        const created = queryParams.get('created');
        const operation = queryParams.get('operation');
        const error = queryParams.get('error');
        if (created === 'true') {
            message.success('Account created successfully! Email verification link sent to your email. Please verify your email to login.');
            shownBefore.current = true;
        } else if (created === 'false') {
            message.error('Account creation failed. Please try again.');
            shownBefore.current = true;
        }
        if (operation === 'failedUpload') {
            message.info('We are sorry, but the file you uploaded was not able to be processed. Please try again.');
            shownBefore.current = true;
        }
        if (error === 'videoProcessingError') {
            message.error('There was an error processing the video. Please try again.');
            shownBefore.current = true;
        }

    }, [queryParams])
 
}
